import { z } from 'zod';
export const ApiErrorCodeSchema = z.enum([
    'bad_request',
    'unauthenticated',
    'unauthorized',
    'not_found',
    'conflict',
    // Spotify gates both the queue read and every playback write behind Premium, so a refusal for
    // that reason is its own answer: nothing about the request was wrong and no retry will help.
    'payment_required',
    'rate_limited',
    'payload_too_large',
    'bad_gateway',
    'internal',
]);
export const ApiErrorSchema = z
    .strictObject({
    error: z
        .strictObject({
        code: ApiErrorCodeSchema,
        message: z.string().min(1),
        /** Field-level validation detail, present only for `bad_request`. */
        issues: z
            .array(z
            .strictObject({
            path: z.string(),
            message: z.string(),
        })
            .readonly())
            .readonly()
            .optional(),
    })
        .readonly(),
})
    .readonly();
export const HEALTH_STATUSES = ['ok', 'degraded'];
export const HealthSchema = z
    .strictObject({
    status: z.enum(HEALTH_STATUSES),
    database: z.enum(HEALTH_STATUSES),
    uptimeSeconds: z.number().nonnegative(),
})
    .readonly();
//# sourceMappingURL=error.js.map